/**
 * Utilidad para limpiar service workers y cachés del navegador
 * Útil durante la migración desde Expo/PWA para evitar problemas de caché
 */

/**
 * Desregistra todos los service workers activos
 */
export async function unregisterServiceWorkers(): Promise<void> {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations.map((registration) =>
        registration.unregister().catch(() => {
          // Ignorar errores al desregistrar
        })
      )
    );
  } catch (error) {
    // Ignorar errores silenciosamente
    console.warn('Error al desregistrar service workers:', error);
  }
}

/**
 * Limpia todos los cachés del navegador
 */
export async function clearCaches(): Promise<void> {
  if (typeof window === 'undefined' || !('caches' in window)) {
    return;
  }

  try {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map((name) =>
        caches.delete(name).catch(() => {
          // Ignorar errores al limpiar cachés
        })
      )
    );
  } catch (error) {
    // Ignorar errores silenciosamente
    console.warn('Error al limpiar cachés:', error);
  }
}

/**
 * Ejecuta todas las operaciones de limpieza
 */
export async function cleanupServiceWorkersAndCaches(): Promise<void> {
  try {
    await Promise.all([unregisterServiceWorkers(), clearCaches()]);
  } catch (error) {
    // Ignorar errores silenciosamente
    console.warn('Error durante la limpieza:', error);
  }
}
